import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  ResolveStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { filter, map } from 'rxjs';
import { Loader } from './shared/components/loader/loader';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgxSonnerToaster, Loader],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly resolving = toSignal(
    inject(Router).events.pipe(
      filter(
        (event) =>
          event instanceof ResolveStart ||
          event instanceof NavigationEnd ||
          event instanceof NavigationError ||
          event instanceof NavigationCancel,
      ),
      map((event) => event instanceof ResolveStart),
    ),
    { initialValue: false },
  );
}
